// TODO: need to synchronize with inface-sdk error code value
const ErrorCode = Object.freeze({
  CHANNEL_TIMEOUT: -110020,
  PARAM_IS_NULL: -110030,
  PARAM_IS_INVALID_JSON: -110031,
  NOT_REGISTERED_ACTION_INVOKER: -110040
})

export { ErrorCode }
